import * as yup from 'yup';
import {
  schemaBoolRequiredSocialName,
  schemaEmailRequired,
  schemaFirstName,
  schemaFullName,
  schemaLastName,
  schemaPasswordRequired,
  schemaSocialName,
  schemaStringCpfRequired,
  schemaStringDateRequired,
  schemaStringPhoneRequired
} from '../SchemaFieldsRequired';

export interface FormSignUpValues {
  email: string;
  password: string;
  checkPassword: string;
  acceptTermsOfUse: boolean;
  firstName: string;
  lastName: string;
  userName: string;
  socialName: string;
  hasSocialName: boolean;
  prefersSocial: boolean;
  birthDate: string;
  cellPhoneNumber?: string;
  cpf?: string;
  socialId?: string;
  provider?: string;
  isSocial?: boolean;
}

export function createForm() {
  const objectFiels = {
    email: schemaEmailRequired,
    password: schemaPasswordRequired,
    // checkPassword: schemaCheckPasswordRequired,
    // acceptTermsOfUse: schemaTermsRequired,
    firstName: schemaFirstName,
    lastName: schemaLastName,
    userName: schemaFullName,
    socialName: schemaSocialName,
    hasSocialName: schemaBoolRequiredSocialName,
    prefersSocial: yup.bool(),
    birthDate: schemaStringDateRequired,
    cellPhoneNumber: schemaStringPhoneRequired,
    cpf: schemaStringCpfRequired,
    provider: yup.string(),
    socialId: yup.string()
  };

  return yup.object(objectFiels);
}
